var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20245 4.92974L3.99947 6.11911C4.16345 6.71145 4.59636 7.44273 5.29819 8.31296C6.00003 9.18318 6.78592 9.96908 7.65589 10.6707C8.52586 11.3722 9.26168 11.8051 9.86336 11.9694L11.0527 10.78C11.1894 10.6433 11.4309 10.5863 11.777 10.6092C12.1231 10.632 12.4717 10.6866 12.8227 10.773C13.1738 10.8594 13.4631 10.9575 13.6906 11.0672C14.201 11.3132 14.5746 11.6163 14.8115 11.9764C15.0484 12.3365 15.062 12.6167 14.8524 12.817L13.3902 14.2796C12.9984 14.6805 12.4653 14.9061 11.791 14.9564C11.1167 15.0067 10.3876 14.9019 9.60378 14.6419C8.81995 14.3819 7.99073 13.9695 7.11609 13.4047C6.24145 12.8399 5.40755 12.161 4.61439 11.3681C3.82122 10.5752 3.14015 9.73908 2.57115 8.85977C2.00216 7.98046 1.58742 7.1489 1.32692 6.36508C1.06643 5.58125 0.961606 4.85451 1.01246 4.18485C1.06331 3.51518 1.28891 2.98433 1.68925 2.59229L3.15182 1.12972C3.3433 0.938241 3.59394 0.958744 3.90373 1.19122C4.21353 1.42369 4.54615 1.79056 4.90161 2.29184C5.07467 2.53781 5.21141 2.97979 5.31181 3.6178C5.41222 4.25581 5.37577 4.69286 5.20245 4.92974Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.04e13b0b.svg";
export { ForwardRef as ReactComponent };